import { createApp } from 'vue';
import NotificationsPage from './NotificationsPage.vue';

let mounted = false;

export function initNotificationsPage(): void {
  const element = document.getElementById('notificationsRoot');
  if (!element || mounted) return;
  createApp(NotificationsPage).mount(element);
  mounted = true;
}
